<template>
    <Sheet v-model:open="open">
        <SheetTrigger as-child>
            <button class="btn-link lg:hidden">Sort <IconSortingArrows /></button
        ></SheetTrigger>
        <SheetContent side="bottom" class="flex h-dvh flex-col gap-0">
            <SheetHeader>
                <SheetTitle>{{ title ?? '' }}</SheetTitle>
                <!-- <SheetDescription> </SheetDescription> -->
            </SheetHeader>
            <div class="flex h-full flex-1 overflow-y-auto">
                <Command class="">
                    <CommandList class="max-h-auto">
                        <CommandGroup
                            v-for="column in columns"
                            :key="column.key"
                            :heading="column.label"
                            class="border-(--border-subtle) p-0 not-first:border-t-1"
                        >
                            <CommandItem
                                :value="`${column.key}`"
                                class="text-md m-1"
                                :selected="selectedKey === `${column.key}-ascending`"
                                @select="() => emit('sortTable', column.key, 'ascending')"
                            >
                                <IconArrowUp />
                                <span :class="selectedKey === `${column.key}-ascending` ? 'font-bold' : ''"
                                    >Ascending</span
                                >
                            </CommandItem>
                            <CommandItem
                                :value="`${column.key}-descending`"
                                class="text-md m-1"
                                :selected="selectedKey === `${column.key}-descending`"
                                @select="() => emit('sortTable', column.key, 'descending')"
                            >
                                <IconArrowDown />
                                <span :class="selectedKey === `${column.key}-descending` ? 'font-bold' : ''"
                                    >Descending</span
                                >
                            </CommandItem>
                            <CommandSeparator />
                        </CommandGroup>
                    </CommandList>
                </Command>
            </div>
            <SheetFooter class="shrink-0">
                <button class="btn-link" @click="emit('clearSorting')">Reset</button>
                <Button @click="closeSheet">
                    <span>Apply</span>
                    <IconCheckDone />
                    <!-- <i class="i-checkmark" /> TODO <IconCheckmark which detect that it is in a btn-primary? -->
                </Button>
            </SheetFooter>
        </SheetContent>
    </Sheet>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetFooter, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import { ref } from 'vue';
import IconSortingArrows from '../icons/IconSortingArrows.vue';
import IconCheckDone from '../icons/IconCheckDone.vue';
import Command from '../ui/command/Command.vue';
import CommandList from '../ui/command/CommandList.vue';
import CommandGroup from '../ui/command/CommandGroup.vue';
import CommandItem from '../ui/command/CommandItem.vue';
import CommandSeparator from '../ui/command/CommandSeparator.vue';
import IconArrowDown from '../icons/IconArrowDown.vue';
import IconArrowUp from '../icons/IconArrowUp.vue';

defineProps<{
    title: string;
    columns: {
        key: string;
        label: string;
    }[];
    selectedKey: string; // column+direction
}>();

const emit = defineEmits<{
    (e: 'sortTable', column: string, direction: 'ascending' | 'descending'): void;
    (e: 'clearSorting'): void;
}>();

const open = ref(false);

function closeSheet() {
    open.value = false;
}
</script>
